import { setConfirm } from "../../store/actions/appAction";
import {
  apiGetTransaction,
  apiSaveInstallmentTransaction,
  apiSaveTransaction, apiUpdateInstallmentTransaction,
  apiUpdateTransaction
} from "api/transactionApi";
import { DateToString } from "components/Reports/DateFilter";
import { ContainedTabsProps } from "components/Tabs/Tabs3";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import shortid from "shortid";
import setTransactionSide from "./funcs/setTransactionSide";
import useCurrency from "helpers/useCurrency";
import { apiFactorsList } from "api/factorApi";
import normalizeDestItems from "./funcs/normalizeDestItems";
import normalizeSourceItems from "./funcs/normalizeSourceItems";
import normalizeTransaction from "./funcs/normalizeTransaction";
import { apiGetInstallment } from "api/installmentApi";
import { apiPersonsList } from "api/personApi";
import { getQueryParam } from "helpers/queryParam";

export default function useTransaction() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { defCur, currencies } = useCurrency();
  let { id, transactionType, installmentId, } = useParams();
  const copy = getQueryParam("copy")
  const location = useLocation();

  const activeOption = ["bank", "person", "cashier", "fund", "pos"];
  const factorIds = location?.state?.factorIds;
  const store = useSelector((state: any) => state);
  const token = store.businessReducer.business.token;
  const [state, setState] = useState<TransactionState>({
    date: DateToString(Date.now()),
    currency: defCur,
  });
  const [sources, setSources] = useState<Source[]>([{ ind: shortid.generate(), edit: true }]);
  const [destinations, setDestinations] = useState<Destination[]>([{ ind: shortid.generate(), edit: copy ? false : true }]);
  const [active, setActive] = useState({ tab: 0, saving: false, edit: false });

  // Change data on edit
  useEffect(() => {
    if (id && transactionType && !installmentId) {
      dispatch(
        apiGetTransaction(
          id,
          transactionType,
          token,
          (t: { transaction: any; transactionItems: TransactionItem[] }) => {
            const transaction = t.transaction;
            installmentId = transaction.installmentId
            const items = setTransactionSide(t);
            let Active = { ...active };
            let type = transaction.type;
            let tab = ["receive", "income"].includes(type) ? 0 : 1;

            setActive({ ...Active, tab, edit: copy ? false : true });
            setState((x) => ({ ...x, ...normalizeTransaction(transaction) }));
            const sourceItems = items.filter((x: any) => x.side === "source");
            const destItems = items.filter((x) => x.side === "destination");
            sourceItems?.length && setSources(normalizeSourceItems(sourceItems, transaction));
            destItems?.length && setDestinations(normalizeDestItems(destItems));
          }
        )
      );
    }
  }, [token, id, transactionType]);

  useEffect(() => {
    if (factorIds && !installmentId && !state.installmentItemId) {

      const fType = active.tab === 0 ? "sale" : "buy";
      dispatch(
        apiFactorsList(token, JSON.stringify([fType]), "transaction", null, (factors: Factor[]) => {
          let tr: Source[] = [];
          for (const id of factorIds) {
            const factor = factors.find((f) => f.id === id);
            if (factor) {
              let typeOption = factor.Person;
              typeOption.title = typeOption.nickName;
              tr.push({
                edit: false,
                ind: shortid.generate(),
                done: true,
                typeOption,
                data: {
                  accounting: factor.accountingCode,
                  factor: factor.id,
                  factorOption: factor,
                  person: factor.Person.id,
                  price: factor.totalPrice,
                  typeOption,
                },
              });
            }
          }
          setSources(tr);
        })
      );
    }
  }, [factorIds]);

  const tabs: ContainedTabsProps = {
    tabs: [
      { label: "دریافت", activeColor: "#1E8E1B" },
      { label: "پرداخت", activeColor: "#CB0B0B" },
    ],
    size: 2,
    minWidth: 100,
    activeTab: active.tab,
    changeViaProps: true,
    onChange: (val) => {
      const reset: any = () => {
        setDestinations([{ ind: shortid.generate(), edit: true }]);
        setSources([{ ind: shortid.generate(), edit: true }]);
        setActive((x: any) => ({ ...x, tab: val }));
      };

      if (destinations.concat(sources).filter((x) => x.done).length > 0) {
        dispatch(setConfirm("همه تراکنش ها ریست خواهند شد، آیا مطمئنید؟", reset));
        return;
      }
      reset();
    },
  };

  function handleSubmit() {
    if (!showInstallmentItem || state.installmentItemId) {
      handleInstallmentSubmit();
    } else {
      const financialTypes: any = ["bank", "fund", "cashier"];
      const sourceType = sources[0]?.type;
      const tTypes: any = {
        receive: active.tab === 0 && sourceType !== "income",
        income: active.tab === 0 && sourceType === "income",
        payment: active.tab === 1 && sourceType !== "cost",
        cost: active.tab === 1 && sourceType === "cost",
      };
      const tType = Object.keys(tTypes).find((x) => !!tTypes[x]);
      const factor = sources[0].data?.factorOption;
      const fType = tabs.tabs[active.tab].label;
      const defDescription = factor ? `سند ${fType} فاکتور شماره ${factor.accountingCode}` : undefined;
      const formData = {
        transaction: {
          accountingCode: state.accountingCode || null,
          date: state.date,
          description: state.description || defDescription,
          factorId: sources[0].data?.factor,
          ProjectId: state.projectId,
          BranchId: state.branchId,
          transactionType: tType,
          currencyExchange: state.currency?.currencyExchange || 1,
          currencyId: state.currency?.id || 1,
        },
        firstItems: sources.flatMap((s) => {
          if (!s.done) return [];
          return {
            amount: s.data?.price,
            optionableId: s.data ? (s.data as any)[s.type || ""] : undefined,
            optionableType: s.type,
            factorId: s.data?.factor,
          };
        }),
        secondItems: destinations.flatMap((d) => {
          if (!d.done) return [];
          return {
            amount: d.data?.price,
            wage: d.data?.wage ?? 0,
            optionableId: d.data ? (d.data as any)[d.type || ""] : undefined,
            optionableType: financialTypes.includes(d.type) ? "financial" : d.type,
            chequeDate: d.data?.date,
            chequeIssuingBank: d.data?.issuingBank,
            chequeBranch: d.data?.branch,
            chequeNumber: d.data?.number ? +d.data.number : undefined,
            sayad: d.data?.sayad,
          };
        }),
      };
      if (active.edit) {
        dispatch(
          apiUpdateTransaction(id, {}, token, null, formData, () => {
            navigate("/transactions");
          })
        );
      } else {
        dispatch(
          apiSaveTransaction({}, token, null, formData, () => {
            navigate("/transactions");
          })
        );
      }
    }
  }

  const titles: any = {
    0: { payment: "دریافت از", transaction: "مقصد دریافت" },
    1: { payment: "پرداخت به", transaction: "مبدا پرداخت" },
  };

  // installment section

  const [installmentInitialData, setInstallmentInitialData] = useState<any>({});
  const [formikInstallmentInitialData, setFormikInstallmentInitialData] = useState<any>([]);
  const [showInstallmentItem, setShowInstallmentItem] = useState(true);
  const initialData = async () => {
    dispatch(
      //@ts-ignore
      apiGetInstallment(installmentId ?? state.installmentId, token, (data: any) => {
        computeInstallMentInitialData(data);
        setInstallmentInitialData(data);
        if (data.profitSettings) {
          let t = JSON.parse(data.profitSettings);
          setFormikInstallmentInitialData(JSON.parse(t));
        }
        //profitSettings
      })
    );
  };

  const computeInstallMentInitialData = (data: any) => {
    let Active = { ...active };
    // let tab = ["receive", "payment"].includes(data.type) ? 0 : 1;
    let tab: any = {
      receive: 0,
      payment: 1,
    };
    setActive({ ...Active, tab: tab[data.type], edit: false });
    dispatch(apiFactorsList(token, '["sale" , "buy"]', "installment"));
    dispatch(apiPersonsList(token, "allPerson"));
    const Installment_Items: {
      id: string;
      price: number;
    }[] = data?.Installment_Items ?? [];
    // @ts-ignore
    const installment = Installment_Items.find((i) => i.id == (state.installmentItemId ? state.installmentItemId : id));
    setSources([
      {
        ind: shortid.generate(),
        edit: false,
        done: true,
        data: {
          price: installment?.price,
        },
      },
    ]);
  };

  const handleInstallmentSubmit = () => {
    const Installment_Items: {
      id: string;
      price: number;
    }[] = installmentInitialData?.Installment_Items ?? [];
    const installment = Installment_Items.find((i) => i.id == id);
    const financialTypes: any = ["bank", "fund", "cashier"];

    const formData = {
      transaction: {
        date: state.date,
        transactionType ,
        description: state.description || installmentInitialData?.description,
        installmentItemId: installment?.id ?? state.installmentItemId,
      },

      secondItems: destinations.flatMap((d) => {
        if (!d.done) return [];
        return {
          amount: d.data?.price,
          wage: d.data?.wage ?? 0,
          optionableId: d.data ? (d.data as any)[d.type || ""] : undefined,
          optionableType: financialTypes.includes(d.type) ? "financial" : d.type,
          chequeDate: d.data?.date,
          chequeIssuingBank: d.data?.issuingBank,
          chequeBranch: d.data?.branch,
          chequeNumber: d.data?.number ? +d.data.number : undefined,
          sayad: d.data?.sayad,
        };
      }),
    };
    if (active.edit || state.installmentId) {
      dispatch(
        apiUpdateInstallmentTransaction(id, {}, token, null, formData, () => {
          navigate("/transactions");
        })
      );
    } else {
      dispatch(
        apiSaveInstallmentTransaction(token, formData, () => {
          navigate("/transactions");
        })
      );
    }
  };

  useEffect(() => {
    if (installmentId || state.installmentId) {
      initialData();
      if (!state.installmentId)
        setShowInstallmentItem(false);
    }

    return () => { };
  }, [installmentId, state.installmentId]);

  return {
    tabs,
    handleSubmit,
    active,
    state,
    setState,
    sources,
    setSources,
    destinations,
    setDestinations,
    titles,
    currencies,
    showInstallmentItem,
    installmentInitialData,
    formikInstallmentInitialData,
    id,
    activeOption,
  };
}
